<template>
    <div class="container">
        <v-dialog v-model="showPayload" width="700">
            <v-card>
                <v-card-title>
                    <h1>View Data</h1>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showPayload = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <pre>{{ currentLog.payload }}</pre>
                </v-card-text>
            </v-card>
        </v-dialog>

        
        <v-card>
            <v-card-title>
                <h1>Activity Logs</h1>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="logs" :search="search" :disable-initial-sort="true" :rows-per-page-items='[10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'>
                    <template v-slot:items="{ item }">
                       
                        <td>
                            <template v-if="item.method == 'POST'">
                                <span v-if="item.uri === '/auth/logout'" class="red--text">{{ item.user_name }} is logged out</span>
                                <span v-else-if="item.uri === '/auth/login'">
                                    <template v-if="item.payload && item.payload.login_status">
                                        <span v-if="item.payload.login_status == 'success'" class="green--text">
                                            {{ item.user_name }} is logged in successfully
                                        </span>
                                        <span v-else-if="item.payload.login_status == 'inactive'" class="red--text">
                                            {{ item.user_name }} is trying logged in with inactive status
                                        </span>
                                        <span v-else-if="item.payload.login_status == 'locked'" class="red--text">
                                            {{ item.user_name }} is trying logged in and his account is locked
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{ item.user_name }} is logged in  with {{ item.payload.login_status }} status
                                    </template>
                                </span>
                                <span v-else  class="green--text">Created</span>
                            </template>
                            <template v-else-if="item.method == 'PUT'">
                                <span class="blue--text">Updated</span> 
                            </template>
                            <template v-else-if="item.method == 'DELETE'">
                                <span class="red--text">Deleted</span> 
                            </template>
                            <template v-else>
                            {{ item.method }}
                            </template>

                            <template v-if="item.uri.includes('user')">
                                user <span v-if="item.payload && item.payload.first_name">{{ item.payload.first_name }} {{ item.payload.last_name }}</span>
                                <span v-if="item.method == 'PUT' && item.payload.status"> Status to <b :class="`${statusColors[item.payload.status]}--text`">{{ item.payload.status }}</b></span>
                            </template>
                            <template v-else-if="item.uri.includes('roles')">
                                role 
                                <span v-if="item.payload && item.payload.name">{{ item.payload.name }}</span>
                                <span v-else>{{ item.uri.replace('/roles/', '') }}</span>
                            </template>
                            <template v-else>
                                <!-- {{ item.uri }} -->
                            </template>
                             
                        </td>
                        <td width="200px">By {{ item.user_name }}</td>
                        <td><v-btn v-if="item.payload && Object.keys(item.payload).length" @click="viewPayload(item)">view data</v-btn></td>
                        <td>{{ item.created_at }}</td>
                        
                    </template>
                </v-data-table>
            </v-card-text>
            
        </v-card>
        
    </div>
</template>
<script>
export default {
    name: "activity-logs",
    data() {
        return {
            headers: [
                { text: "Action", value: "method" },
                { text: "Action By", value: "user_name" },
                { text: "data", value: "payload" },
                { text: "Happened At", value: "created_at", sortable: true },
            ],
            logs: [],
            search: "",
            currentLog: {},
            showPayload: false,
            statusColors: {
                pending: "warning",
                approved: "success",
                rejected: "error",
                blocked: "error",
                locked: "error",
            },
        }
    },
    mounted() {
        this.getAllLogs();
    },
    methods: {
        getAllLogs() {
            this.$http.get("/activity-logs").then((response) => {
                this.logs = response.data
            }).catch((error) => {
                if (error.response.status === 401) {
                    // common.logOut();
                }
            });
        },
        viewPayload(item) {
            this.currentLog = item;
            this.showPayload = true;
        }
    }
}
</script>